/* eslint-disable */
import axios from 'axios';
import loading from './loading.js';
var qs = require('qs');
var instance = axios.create({
    // baseURL: 'http://hi-api.xbx12.top/',
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*'
    },
    // mode: 'cors',
});
const ajax = (url, params, type = 'get', isloading = false) => {
    return new Promise((resolve, reject) => {
        if (isloading) {
            loading.showLoading();
        }
        instance({
            url: url,
            method: type,
            data: type == 'post' ? params : undefined,
            params: type == 'get' ? params : undefined
        }).then(res => {

            if (res.status == 200 && res.data.status == 0) {

                resolve(res.data.data);
                loading.hideLoading()
            } else {
                throw res;

            }
        }).catch(err => {
            loading.hideLoading()
            console.error(err);
            reject(err);
        })
    })
};

export default ajax;



// WEBPACK FOOTER //
// ./src/js/ajax.js